import type { SortingStrategy } from '@dnd-kit/sortable';
import type { CSSProperties } from 'react';
import { tokens } from 'smoothie';

// orchidPink700 — soft mauve-pink for drag overlay border/shadow
export const DRAG_PINK = tokens.color.light.orchidPink.orchidPink700;
export const DRAG_PINK_SHADOW = 'rgba(233, 166, 187, 0.25)';

// gray200 — pale cool-gray ghost placeholder background
export const GHOST_BG = tokens.color.light.gray.gray200;

// gray100 — near-white card hover background
export const CARD_HOVER_BG = tokens.color.light.gray.gray100;

/** Horizontal drag distance (px) that triggers delete mode. */
export const DELETE_THRESHOLD = 80;

/** Pink selection / drop-indicator stroke (px). In-list uses inward outline; portaled overlays use outer shadow. */
export const GOAL_DRAG_STROKE_PX = 4;

/**
 * Minimum height of a group goal row (`GroupGoalRow`). Sortable placeholders
 * must match so @dnd-kit vertical list layout does not leave stray gaps.
 */
export const GROUP_GOAL_ROW_MIN_HEIGHT = 96;

/**
 * Outer ring for portaled drag overlays (not clipped by scroll ancestors).
 */
export const goalDragRingShadow = (color: string) =>
    `0 0 0 ${GOAL_DRAG_STROKE_PX}px ${color}`;

/**
 * Inward outline ring for list tiles and goal sets. Paints on top of opaque
 * children (e.g. group header) so the stroke is visible on all four sides;
 * inset box-shadow sits under descendants and loses the top segment.
 */
export const goalTileFocusRingStyle = (color: string): CSSProperties => ({
    outline: `${GOAL_DRAG_STROKE_PX}px solid ${color}`,
    outlineOffset: -GOAL_DRAG_STROKE_PX,
});

// red900 / red1000 / red200 — delete mode indicator colors
export const DELETE_RED = tokens.color.light.red.red900;
export const DELETE_DARK_RED = tokens.color.light.red.red1000;
export const DELETE_LIGHT_BG = tokens.color.light.red.red200;
export const DELETE_SHADOW = 'rgba(240, 68, 56, 0.2)';

// Top-level items stay in place during drag; only the line/outline
// indicators show where the drop will go. The inside-group context
// uses verticalListSortingStrategy for animated reordering.
export const staticSortingStrategy: SortingStrategy = () => null;
